var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggridColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8356 3.3291C16.2958 3.3291 16.6689 3.7022 16.6689 4.16243V15.8347C16.6689 16.2949 16.2958 16.668 15.8356 16.668H10.8328C10.3726 16.668 9.9995 16.2949 9.9995 15.8347V4.16243C9.9995 3.7022 10.3726 3.3291 10.8328 3.3291L15.8356 3.3291Z",
    stroke: "#8E8D89",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.3348 3.3291V16.668",
    stroke: "#8E8D89",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83073 9.99902C6.29097 9.99902 6.66406 10.3721 6.66406 10.8324V16.6688C6.66406 17.1291 6.29097 17.5021 5.83073 17.5021H4.16267C3.70244 17.5021 3.32934 17.1291 3.32934 16.6688L3.32934 10.8324C3.32934 10.3721 3.70244 9.99902 4.16267 9.99902H5.83073Z",
    stroke: "#8E8D89",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M4.99744 7.49646L3.33008 5.8291",
    stroke: "#8E8D89",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M6.66541 5.8291L4.99805 7.49646",
    stroke: "#8E8D89",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M4.99692 2.49609V7.49818",
    stroke: "#8E8D89",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggridColumns);
export default __webpack_public_path__ + "static/media/aggrid-columns.08257f471a104c442da10307ac153a3d.svg";
export { ForwardRef as ReactComponent };